var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37402 16C4.85736 16 3.56169 15.475 2.48702 14.425C1.41169 13.375 0.874023 12.0917 0.874023 10.575C0.874023 9.275 1.26569 8.11667 2.04902 7.1C2.83236 6.08333 3.85736 5.43333 5.12402 5.15C5.54069 3.61667 6.37402 2.375 7.62402 1.425C8.87402 0.475 10.2907 0 11.874 0C13.824 0 15.478 0.679 16.836 2.037C18.1947 3.39567 18.874 5.05 18.874 7C20.024 7.13333 20.9784 7.629 21.737 8.487C22.495 9.34567 22.874 10.35 22.874 11.5C22.874 12.75 22.4367 13.8127 21.562 14.688C20.6867 15.5627 19.624 16 18.374 16H12.874C12.324 16 11.8534 15.8043 11.462 15.413C11.07 15.021 10.874 14.55 10.874 14V8.85L9.27402 10.4L7.87402 9L11.874 5L15.874 9L14.474 10.4L12.874 8.85V14H18.374C19.074 14 19.6657 13.7583 20.149 13.275C20.6324 12.7917 20.874 12.2 20.874 11.5C20.874 10.8 20.6324 10.2083 20.149 9.725C19.6657 9.24167 19.074 9 18.374 9H16.874V7C16.874 5.61667 16.3867 4.43733 15.412 3.462C14.4367 2.48733 13.2574 2 11.874 2C10.4907 2 9.31169 2.48733 8.33702 3.462C7.36169 4.43733 6.87402 5.61667 6.87402 7H6.37402C5.40736 7 4.58236 7.34167 3.89902 8.025C3.21569 8.70833 2.87402 9.53333 2.87402 10.5C2.87402 11.4667 3.21569 12.2917 3.89902 12.975C4.58236 13.6583 5.40736 14 6.37402 14H8.87402V16H6.37402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackup);
export default __webpack_public_path__ + "static/media/backup.b098ee78f780711199003231061cbcc6.svg";
export { ForwardRef as ReactComponent };